var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ConditionsCard',_vm._g({attrs:{"patient-id":_vm.patientId,"info-title":_vm.infoTitle,"category":"psychological","show-quick-add":_vm.showQuickAdd,"icon":"mdi-brain"}},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }